import React from "react";
import { PaymentIcon } from "../../assets/icons";

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Payments
          </h1>
          <p className="text-gray-600 mb-6">
            Payment plans are coming soon! We're working hard to bring you the best payment experience.
          </p>
        </div>
        
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-blue-900 mb-2">
              What's Coming
            </h3>
            <ul className="text-sm text-blue-800 space-y-1 text-left">
              <li>• Flexible payment plans</li>
              <li>• Secure payment processing</li>
              <li>• Payment history tracking</li>
              <li>• Automated billing</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm text-gray-600">
              Stay tuned for updates! We'll notify you as soon as payment features are available.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
